import { z } from 'zod';

const TemplateBuilderQuestionSchema = z.object({
	_id: z.string().optional(),
	text: z.string(),
	answer: z.string().nullable(),
	transformedAnswer: z.string().optional().nullable(),
	heading: z.string().nullable(),
	description: z.string().nullable(),
	proTip: z.string().nullable(),
	rfpSections: z.string().array(),
	order: z.union([z.string(), z.number()]),
});
const DropdownOption = z.object({
	label: z.string(),
	value: z.string(),
});
const SectionBuilderSchema = z.object({
	wordCount: z.union([z.string(), z.number()]),
	requiredRfpSections: z.string().array(),
	solicitationSectionDropdown: z.array(DropdownOption).nonempty({
		message: 'Information required from the solicitation is required.',
	}),
	children: z.array(z.lazy(() => SectionBuilderSchema)),
});
const tagSchema = z.object({
	label: z.string(),
	organizationIdentifier: z.string().optional().nullable(),
	value: z.string(),
});
export const TemplateBuilderSchema = z.object({
	_id: z.string().optional(),
	name: z.string(),
	description: z.string(),
	tags: z.union([z.string().array(), z.array(tagSchema)]),
	isLive: z.boolean(),
	organizationIdentifier: z.string(),
	questions: z.array(TemplateBuilderQuestionSchema),
	sections: z.array(SectionBuilderSchema),
});
